export default "__VITE_ASSET__BH1T$9_R__"